var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-end"},[_c('b-button',{attrs:{"variant":"outline-primary"},on:{"click":_vm.navigateToUsersPage}},[_vm._v(" تراجع ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }